import {useEffect, useState} from 'react';

// NOTE: ultimately we should have a public property context but atm it is not worth doing since we
// are so far from having our entire app wrapped/converted to react
import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {publicProperties} from '@netx/core-app/collections/singleton/publicProperties';

/**
 * Get and track value for a public property
 * @param property Public property
 * @param asBoolean Value as boolean
 * @example
   const userLoginProperty = usePublicProperty('viewer.userLogin');
 */
export function usePublicProperty(
	property: string,
	asBoolean?: false,
): string | undefined;

export function usePublicProperty(
	property: string,
	asBoolean: true,
): boolean | undefined;

export function usePublicProperty(property: string, asBoolean = false) {
	const [value, setValue] = useState<string | boolean>();
	useEffect(() => {
		const update = () => {
			setValue(getPublicProperty(property, asBoolean as any));
		};

		publicProperties.on('change sync saved', update);

		update();

		return () => {
			publicProperties.off('change sync saved', update);
		};
	}, [property, asBoolean]);

	return value;
}
export default usePublicProperty;
